import { createFileRoute } from '@tanstack/react-router';
import { WizardStepRouteView } from '@/pages/workspaces/imports/routing';
import { LastWorkspaceResolver } from './-components';
import { validateWizardSearch } from './-import-wizard-search';
import { ImportValidatingPage } from './-route-pages';

/** No `appBundle`: this URL has no `journeys` segment for the resolver to rebuild from. */
function ImportValidatingRoute() {
  return (
    <LastWorkspaceResolver>
      <WizardStepRouteView step="validating">
        <ImportValidatingPage />
      </WizardStepRouteView>
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/imports/$importId/setup/validating')({
  validateSearch: validateWizardSearch,
  component: ImportValidatingRoute,
});
